const bn = {
  today: "আজকের ম্যাচ",
  live: "লাইভ",
  upcoming: "আসন্ন",
  stats: "ম্যাচ পরিসংখ্যান",
  noLive: "এখন কোনো লাইভ ম্যাচ নেই",
  clickForStats: "সম্পূর্ণ পরিসংখ্যানের জন্য ক্লিক করুন",
  viewOdds: "লাইভ অডস দেখুন →",
  headToHead: "মুখোমুখি",
  form: "বর্তমান ফর্ম",
  goalStats: "গোল পরিসংখ্যান",
  leagueTable: "লিগ টেবিল",
  injuries: "আঘাত এবং বাতিল",
  outcome: "সম্ভাব্য ফলাফল",
  homeWin: "হোম জয়",
  draw: "ড্র",
  awayWin: "অ্যাওয়ে জয়",
  confidence: "আত্মবিশ্বাস",
  viewing: "জন দেখছেন",
  subscribe: "সাপ্তাহিক বিশ্লেষণ পান বিনামূল্যে",
  subscribeDesc: "প্রতি শুক্রবার — শীর্ষ ৫টি ম্যাচ পরিসংখ্যান সহ।",
  yourEmail: "আপনার ইমেইল",
  subscribe_btn: "বিনামূল্যে সাবস্ক্রাইব করুন",
  worldCup: "ফিফা বিশ্বকাপ ২০২৬",
  daysAway: "দিন বাকি",
  viewQualifiers: "কোয়ালিফায়ার দেখুন",
  featuredMatches: "🔥 বড় ম্যাচসমূহ",
  favourite: "প্রিয় দল",
  addFav: "প্রিয়তে যোগ করুন",
  removeFav: "প্রিয় থেকে সরান",
  kickoff: "কিক-অফ",
  stadium: "মাঠ",
  season: "সিজন পূর্বাভাস",
  loading: "ম্যাচ লোড হচ্ছে...",
  avgScored: "গড় গোল",
  avgConceded: "গড় হজম",
};
export default bn;